<template>
  <div class="bind-policy-again-face-success">
    <div v-if="!failMsg" class="note">人脸识别成功，正在绑定您的招商信诺保单...</div>
    <div v-if="failMsg">
      <div class="note">{{failMsg}}</div>
      <div v-if="enableFace" @click="goToFace" class="btn">继续识别</div>
      <div @click="goToSMS" class="btn">短信验证</div>
    </div>
  </div>
</template>

<script>
import {
  again
} from "../../components/bind-policy/utils.js";
import {
  BIND_FAIL_ERRORS
} from "../../components/bind-policy/enum.js";
import {
  BIND_POLICY
} from "@/enum/MEMBER_IMG_CODE_TYPE.js";

export default {
  props: {
    from: String
  },
  data() {
    return {
      failMsg: "",
      enableFace: again.enableFace()
    };
  },
  mounted() {
    // 取出存储的上一次请求参数，绑定保单成功，跳回来源页面，绑定失败提示
    again.getStorage({
      success: (result) => {
        const requestParams = result.requestParams;

        requestParams.data.hasFace = "Y";
        // 需要重置action为BIND_POLICY
        requestParams.data.action = BIND_POLICY;

        this.$http(requestParams)
          .then(
            (data) => {
              if (data.respCode == "00") {
                this.$router.replace("/" + this.from);
              } else {
                this.bindFail(data);
              }
            },
            (error) => {
              // 网络问题导致失败，也需要显示出来
              this.failMsg = error.message;
            }
          );
        }
      }
    );
  },
  methods: {
    goToFace() {
      again.goToFace({ from: this.from });
    },
    goToSMS() {
      this.$router.replace(`/bind-policy-again/sms?from=${this.from}`);
    },
    bindFail(data) {
      if (data.respData && "errorCode" in data.respData) {
        this.failMsg = BIND_FAIL_ERRORS[data.respData.errorCode];
			} else {
        this.failMsg = data.respDesc;
			}
    }
  }
}
</script>

<style scoped>
.note {
  padding: 10px 0;
  text-align: center;
}
.btn {
  width: 3.2rem;
  height: .49rem;
  color: #fff;
  background: #4181ff;
  border-radius: 5px;
  text-align: center;
  line-height: .49rem;
  font-size: .15rem;
  margin: .18rem auto;
}
</style>